module.exports = __webpack_public_path__ + "static/media/interview32_s.b82d26ab.jpg";